import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { globals } from 'src/app/globals';
import { ToastService } from '../../services/toast.service';
import { userService } from '../../services/user.service';
import { dataService } from '../../services/data.service';

import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { WeekViewHourSegment } from 'calendar-utils';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from 'date-fns';
import { fromEvent, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.page.html',
  styleUrls: ['./scheduler.page.scss'],
})
export class SchedulerPage implements OnInit {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  colours: any = {
    red: {
      primary: '#DC0032',
      secondary: '#DC0032',
    },
    yellow: {
      primary: '#f4c031',
      secondary: '#f4c031',
    },
    blue: {
      primary: '#6987c9',
      secondary: '#6987c9',
    },
    black: {
      primary: '#000',
      secondary: '#000',
    },
    grey: {
      primary: '#98bbcc',
      secondary: '#98bbcc',
    },
    green: {
      primary: '#19c085',
      secondary: '#19c085',
    },
    orange: {
      primary: '#ff8c00',
      secondary: '#ff8c00',
    },
  };
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  user: any = {};
  users: any = {};
  scheduler: any = {};
  viewDate = new Date();
  weekStartsOn: 1 = 1;
  dragToCreateActive = false;
  days: any[] = [];
  slots: any[] = [];
  selectedEvent: any;
  newEvent: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    public userService: userService, 
    public dataService: dataService, 
    private router: Router,
    private toastService: ToastService,
    private http: HttpClient
  ) {}

  refresh = new Subject<void>();

  activeDayIsOpen: boolean = true;

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.getEventDetail(event)
  }

  getEventDetail(event: any) {
    this.selectedEvent = this.scheduler.find(x => x.id === event.id);
  }

  addEventParticipant() {
    
    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'addSchedulerEventParticipant')

    const body = {
      id: this.user.id,
      schedule: this.selectedEvent.id,
      user: this.selectedEvent.newParticipant,
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            
            if (this.selectedEvent.participants) {
              this.selectedEvent.participants.push({
                id: this.selectedEvent.newParticipant,
                name: response.body.name
              })
            }
            else {
              this.selectedEvent.participants = [{
                id: this.selectedEvent.newParticipant,
                name: response.body.name
              }]
            }

            this.toastService.showToast({ header: 'Success', message: 'User has been added as an event participant' });
            this.selectedEvent.newParticipant = '';
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting user data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting user data' });
        }
      );
  }

  addNewEventParticipant() {

    var selectedUser = this.users.find(x => x.id === this.newEvent.newParticipant);

    if (this.newEvent.participants.length > 0) {
      this.newEvent.participants.push({
        id: this.newEvent.newParticipant,
        name: selectedUser.name
      })
    }
    else {
      this.newEvent.participants = [{
        id: this.newEvent.newParticipant,
        name: selectedUser.name
      }]
    }
    this.toastService.showToast({ header: 'Success', message: 'User has been added as an event participant' });
    this.newEvent.newParticipant = '';

  }

  updateSelectedEvent() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'updateScheduleEvent')

    const body = {
      id: this.user.id,
      event: this.selectedEvent
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.toastService.showToast({ header: 'Success', message: 'Scheduler data updated' });
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong updating scheduler data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong updating scheduler data' });
        }
      );

  }

  closeEvent() {
    this.selectedEvent = '';
    this.getScheduler();
  }

  deleteEvent() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'deleteScheduleEvent')

    const body = {
      id: this.user.id,
      eid: this.selectedEvent.id
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.toastService.showToast({ header: 'Success', message: 'Event has been deleted' });
            this.getScheduler();
            this.selectedEvent = '';
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong deleting your event' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong  deleting your event' });
        }
      );

  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: this.colours.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  add() {
    this.newEvent = {
      participants: [{
        id: this.user.id,
        name: this.user.first_name + ' ' + this.user.last_name
      }],
      frequency: 1,
      type: 1
    };
  }

  createEvent() {
    console.log(this.newEvent);
    if (this.newEvent.date && this.newEvent.start && this.newEvent.finish && this.newEvent.title) {
      const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

      const param = new HttpParams()
        .set('apiKey', globals.key)
        .set('apiToken', this.user.token)
        .set('apiFunctionName', 'addSchedulerEvent')

      const body = {
        id: this.user.id,
        cid: this.user.cid,
        sid: this.user.sid,
        event: this.newEvent
      };

      this.http
        .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
        .subscribe(
          (response: any) => {
            if (response.body.success == true && response.body.insertedId > 0) {
              this.toastService.showToast({ header: 'Success', message: 'Event has been created' });
              this.newEvent = '';
              this.getScheduler();
            }
            else {
              this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong creating event' });
            }
          },
          (error: any) => {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong creating event' });
          }
        );
    }
    else {
      this.toastService.showToast({ header: 'Error', message: 'Event must contain: Title, Date, Start, Finish' });
    }

  }

  closeNewEvent() {
    this.newEvent = '';
  }

  /* deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  } */

  setView() {
    if (this.view == CalendarView.Day) {
      this.view = CalendarView.Week;
    }
    else if (this.view == CalendarView.Week) {
      this.view = CalendarView.Month;
    }
    else {
      this.view = CalendarView.Day;
    }
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  events: CalendarEvent[] = [];

  getScheduler() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getScheduler')

    const body = {
      sid: this.user.sid,
      id: this.user.id,
      pid: this.user.pid
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.scheduler = response.body.dataArray;

            while(this.events.length > 0) {
              this.events.pop();
            }
            for (const value of this.scheduler) {

              value.start = new Date(value.startdate + ' ' + value.starttime + ':00');
              value.end = new Date(value.enddate + ' ' + value.endtime + ':00');

              if (value.allday != 1) {
                var allDay = false;
              }
              else {
                var allDay = true;
              }

              this.events.push({
                  actions: value.actions,
                  draggable: true,
                  resizable: {
                    "afterEnd": true,
                    "beforeStart": true
                  },
                  start: value.start,
                  end: value.end,
                  allDay: allDay,
                  title: value.title,
                  color: {
                    primary: value.colour,
                    secondary: value.colour
                  },
                  id: value.id
              });

            }

            this.refresh.next();

          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting scheduler data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting scheduler data' });
        }
      );

  }

  getUsers() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getUsers')

    const body = {
      id: this.user.id,
      sid: this.user.sid,
      pid: 0
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.users = response.body.dataArray;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting user data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting user data' });
        }
      );

  }

  returnZero() {
    return 0
  }

  ngOnInit() {
    this.user = this.userService.getData();
    this.getScheduler();
    this.getUsers();
  }

}
